import * as React from "react"

const Dialog = ({ open, onOpenChange, children }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4">
        {children}
      </div>
    </div>
  );
};

const DialogContent = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={`relative overflow-auto ${className}`}
      {...props}
    >
      {children}
    </div>
  );
});
DialogContent.displayName = "DialogContent";

const DialogHeader = ({ className, children, ...props }) => {
  return (
    <div
      className={`mb-4 ${className || ''}`}
      {...props}
    >
      {children}
    </div>
  );
};
DialogHeader.displayName = "DialogHeader";

const DialogTitle = ({ className, children, ...props }) => {
  return (
    <h2
      className={`text-xl font-semibold mb-2 ${className || ''}`}
      {...props}
    >
      {children}
    </h2>
  );
};
DialogTitle.displayName = "DialogTitle";

const DialogDescription = ({ className, children, ...props }) => {
  return (
    <p
      className={`text-sm text-gray-500 ${className || ''}`}
      {...props}
    >
      {children}
    </p>
  );
};
DialogDescription.displayName = "DialogDescription";

const DialogFooter = ({ className, children, ...props }) => {
  return (
    <div
      className={`mt-4 flex justify-end space-x-2 ${className || ''}`}
      {...props}
    >
      {children}
    </div>
  );
};
DialogFooter.displayName = "DialogFooter";

export {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter
}